module.exports = __webpack_public_path__ + "img/emoji/justripe.ccf98670fa8494628c3320bc9a1d783d.png";